import React from 'react';
import classnames from 'classnames';
import DatePicker from '../DatePicker';
import ClientInfoFields from '../ClientInfoFields';
// import PhoneNumber from '../PhoneNumber';
import { bookAppointment } from '../../services/appointments';
import Select from '../Select';
import './styles.scss';

export default class ScheduleTourForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      appointmentLocalTime: null, // the date comes in as a prop
      allowSmsReminders: true,
      showClientForm: false,
      datePickerFocused: false,
      virtualTour: false,
      virtualPlatform: '',
      // hasAttempted submit refers to whether the user has
      // *ever* tried to submit the form; not the status of their
      // current submission attempt, which is covered by submissionStatus.
      hasAttemptedSubmit: false,
      appointmentError: false,

      // not-started, in-progress, success, or error.
      submissionStatus: 'not-started',
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ hasAttemptedSubmit: true });

    const clientInfoForm = this.refs['client-info-form'];
    if (!this.state.appointmentLocalTime) {
      this.setState({ appointmentError: true });
      return;
    }
    if (!clientInfoForm.validate({ autoFocus: true })) {
      return;
    }

    this.setState({ submissionStatus: 'in-progress' });

    // Track form submission (for remarketing and GTM)
    /* eslint-disable no-undef */
    if (typeof window !== 'undefined') {
      typeof window.google_trackConversion === 'function' &&
        window.google_trackConversion({
          google_conversion_id: 878503069,
          google_conversion_label: 'fFsLCJmmn3AQncnzogM',
          google_remarketing_only: false,
        });

      Array.isArray(window.dataLayer) &&
        window.dataLayer.push({
          event: 'appointment-form-submitted-successfully',
        });
    }
    /* eslint-enable no-undef */

    bookAppointment(
      this.props.desiredDate,
      this.state.appointmentLocalTime,
      this.state.allowSmsReminders,
      clientInfoForm.getData(),
      this.state.virtualTour,
      this.state.virtualPlatform,
      this.props.utmParams
    ).then(
      () => {
        this.setState({ submissionStatus: 'success' });
      },
      (e) => {
        this.setState({ submissionStatus: 'error' });
        // eslint-disable-next-line no-undef
        typeof Raven !== 'undefined' && Raven.captureException(e);
      }
    );
  }

  render() {
    // If the submission succeeded,
    // show the confirmation screen rather than the form.
    if (this.state.submissionStatus === 'success') {
      return (
        <div className="schedule-tour-form schedule-tour-form--submission-status">
          <h1 className="h2">THANK YOU!</h1>
          <div>
            <p>A leasing associate will be in touch with you shortly.</p>
            {/* <p>After <strong>ONE HOUR</strong>, if you have not confirmed, your appointment will be released.</p> */}
          </div>
        </div>
      );
    }

    // Likewise, show an error screen on errors.
    if (this.state.submissionStatus === 'error') {
      return (
        <div className="schedule-tour-form schedule-tour-form--submission-status">
          <div>
            <p>
              We are very sorry, the time you selected is not available. Please
              try again or call us directly at{' '}
              <a href="tel:7182220066">718.222.0066</a>
            </p>
          </div>
        </div>
      );
    }

    // Default case. submissionStatus === in-progress or not-started; show form.
    const hasChosenDate = Boolean(this.props.desiredDate);
    const timesForDate = this.props.availableTimesForDate;
    const timesForDateLoaded = Boolean(timesForDate && timesForDate.times);
    const timesForDateLoading = Boolean(timesForDate && timesForDate.isLoading);
    // console.log(
    //   'props/timesForDate/timesForDateLoaded/timesForDateLoading',
    //   this.props,
    //   timesForDate,
    //   timesForDateLoaded,
    //   timesForDateLoading
    // );
    const isSubmitting = this.state.submissionStatus === 'in-progress';

    return (
      <div className="schedule-tour-form schedule-tour-form--form">
        <h1 className="h2">Schedule an Appointment</h1>
        <form onSubmit={this.handleSubmit}>
          <fieldset>
            <legend>Date & Time</legend>
            <DatePicker
              id="appointmentDateInput"
              date={this.props.desiredDate}
              required={true}
              placeholder={'Choose Appointment Date mm/dd/yyyy'}
              focused={this.state.datePickerFocused}
              onFocusChange={({ focused }) => {
                this.setState({ datePickerFocused: focused });
              }}
              onDateChange={(newDate) => {
                this.props.onChangeAppointmentDate(newDate);
                this.setState({ appointmentError: false });
              }}
              numberOfMonths={1}
            />

            <Select
              key={this.props.desiredDate}
              id="appointmentTimeInput"
              error={this.state.appointmentError}
              options={
                hasChosenDate && timesForDateLoaded
                  ? timesForDate.times.map((time) => ({
                      id: time,
                      label: formatTime(time),
                    }))
                  : []
              }
              onSelect={(option) =>
                this.setState({
                  appointmentLocalTime: option.id,
                  appointmentError: false,
                  // After the user's picked a time, we show the client form
                  // (even if they later go back and edit the date/time).
                  showClientForm: true,
                })
              }
              asFormControl={true}
              required={true}
              noOptionsText={'No available times on this day'}
              noSelectionText={(() => {
                if (!hasChosenDate) {
                  return 'Choose a date first to see available times...';
                } else if (timesForDateLoading) {
                  return 'Loading available times...';
                } else {
                  return 'Choose a time...';
                }
              })()}
              disabled={!(hasChosenDate && timesForDateLoaded)}
            />
          </fieldset>
          <fieldset>
            <legend>Tour Type</legend>
            <Select
              placeholder={'Choose Tour Type'}
              id="appointmentVirtual"
              required={true}
              options={[
                { id: false, label: 'In Person - Agent Guided' },
                { id: true, label: 'Live Video Tours' },
              ]}
              onSelect={(option) =>
                this.setState({
                  virtualTour: option.id,
                  virtualPlatform: option.id ? this.state.virtualPlatform : '',
                })
              }
              noSelectionText={(() => {
                return 'Choose Tour Type';
              })()}
              asFormControl={true}
              noOptionsText={'No available times on this day'}
            />
            {this.state.virtualTour && (
              <Select
                placeholder={'Choose Platform'}
                id="appointmentVirtual"
                options={[
                  { id: 'facetime', label: 'Facetime' },
                  { id: 'zoom', label: 'Zoom' },
                ]}
                noSelectionText={(() => {
                  return 'Choose a platform';
                })()}
                onSelect={(option) =>
                  this.setState({
                    virtualPlatform: option.id,
                  })
                }
                asFormControl={true}
                disabled={!this.state.virtualTour}
              />
            )}
          </fieldset>
          <fieldset>
            <div className="checkbox-inline">
              <label>
                <input
                  type="checkbox"
                  value="allowSmsReminders"
                  checked={this.state.allowSmsReminders}
                  onChange={(e) =>
                    this.setState({ allowSmsReminders: e.target.checked })
                  }
                />
                Remind me before my appointment via SMS
              </label>
            </div>
          </fieldset>
          {this.state.showClientForm && (
            <fieldset>
              <legend>Contact Information</legend>
              <ClientInfoFields
                ref="client-info-form"
                validateOnBlur={this.state.hasAttemptedSubmit}
                submissionStatus={this.state.submissionStatus}
                options={[
                  { id: 2000, label: '$2000' },
                  { id: 2500, label: '$2500' },
                  { id: 3000, label: '$3000' },
                  { id: 3500, label: '$3500' },
                  { id: 4000, label: '$4000' },
                  { id: 4500, label: '$4500' },
                  { id: 5000, label: '$5000' },
                  { id: 5500, label: '$5500' },
                  { id: 6000, label: '$6000' },
                  { id: 6500, label: '$6500' },
                  { id: 7000, label: '$7000+' },
                ]}
              />
            </fieldset>
          )}
          <p
            style={{
              fontSize: '12px',
              lineHeight: '14px',
              paddingBottom: '15px',
            }}
          >
            By selecting Submit, you agree that Two Trees and its affiliates may
            call/text you about your inquiry, which may involve use of automated
            means and prerecorded/artificial voices. You don't need to consent
            as a condition of buying any property, goods, or services.
            Message/data rates may apply.
          </p>
          {this.state.showClientForm && (
            <button
              tabIndex="0"
              role="button"
              className={classnames(
                'button button--primary button--submit-btn',
                { 'button--loading': isSubmitting }
              )}
            >
              {isSubmitting ? (
                <span className="spinner"></span>
              ) : (
                'Make Appointment'
              )}
            </button>
          )}
        </form>
      </div>
    );
  }
}

function formatTime(time) {
  const parts = time.split(':');
  const hour = parseInt(parts[0], 10);
  const hourAmPM = [hour - (hour > 12 ? 12 : 0), hour < 12 ? 'AM' : 'PM'];

  return hourAmPM[0] + ':' + parts[1] + ' ' + hourAmPM[1];
}



// WEBPACK FOOTER //
// ./client/components/ScheduleTourForm/index.js